export enum SurveyStatus {
  READY_TO_BE_ASSIGNED = 'Ready to be assigned',
  ASSIGNED = 'Assigned',
  SURVEY_PROCESS_COMPLETE = 'Survey Process Complete',
  IN_PROGRESS = 'In progress',
  SURVEY_SUBMITTED = 'Survey Submitted',
  SURVEY_FINDINGS_APPROVED = 'Survey Findings Approved',
  DECLINED = 'Declined',
  ACCEPTED = 'Accepted',
  REACTIVATED = 'Reactivated',
  CANCELLED = 'Cancelled'
}
